import { isEmpty } from 'lodash';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getMobileDeviceTags(
  deviceTypes: TargetingBaseType['deviceTypes'],
  deviceOsV2: TargetingBaseType['deviceOsV2'],
  connectionTypes: TargetingBaseType['connectionTypes']
): TagItem[] {
  const result: TagItem[] = [];
  if (!isEmpty(deviceTypes)) {
    result.push({ label: deviceTypes[0] });
  }
  if (deviceOsV2.length > 0) {
    result.push({ label: `${deviceOsV2.length} OS` });
  }
  if (connectionTypes.length > 0) {
    result.push({ label: `${connectionTypes.length} connections` });
  }

  return result;
}
